// extracted by mini-css-extract-plugin
export default {"hero":"Home_hero__zif0N","home":"Home_home__87rdL"};